import React, { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { AppInitialProps } from 'next/app';
import { compose } from 'redux';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@gu-corp/gu-ui';

import { withAccount } from '~/hooks/with-account';
import { withApolloClient } from '~/graphql/client';
import Layout from '~/components/layout';
import HowLendingWorks from './how-lending-works';
import LendingPlans from './lending-plans';
import FAQLending from './lending-faq';
import LendingHistory from './lending-history';
import { withLendingData } from '~/hooks/with-lending-data';
import { useRouter } from 'next/router';

interface Props extends AppInitialProps {}

const Lending = (props: Props) => {
  const { t } = useTranslation('common');
  const router = useRouter();

  const { tab } = router.query;
  const defaultTab = tab === 'history' ? 'history' : 'overview';

  const onTabChange = useCallback(
    (value: string) => {
      router.push(
        {
          pathname: router.pathname,
          query: value === 'overview' ? {} : { tab: value },
        },
        undefined,
        { shallow: true },
      );
    },
    [router],
  );

  return (
    <Layout
      pageTitle={t('lending_overview_page.title')}
      pageDescription={t('lending_overview_page.description')}
    >
      <Tabs value={defaultTab} onValueChange={onTabChange}>
        <TabsList className="mb-6">
          <TabsTrigger value="overview" data-testid="lending-tab-overview">
            {t('lending_overview_page.title')}
          </TabsTrigger>
          <TabsTrigger value="history" data-testid="lending-tab-history">
            {t('lending_page.lending_history')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-8">
          <HowLendingWorks />
          <LendingPlans />
          <FAQLending />
        </TabsContent>

        <TabsContent value="history">
          <LendingHistory />
        </TabsContent>
      </Tabs>
    </Layout>
  );
};

export default compose(withApolloClient, withAccount, withLendingData)(Lending);
